// Copy describing when an automated email fires, shown under Sending Rules
// in the edit view.
//
// Kept in its own module so it can be unit tested without pulling in the
// Lexical editor tree that EditTemplate/index.js imports.

// Trailing context for time_before/time_after triggers, appended after the
// trigger-value dropdown.
export const TRIGGER_CONTEXT = {
  time_before: "before inspection starts.",
  time_after: "after inspection ends.",
};

// Per-event override of TRIGGER_CONTEXT, for events whose time offset is
// measured from something other than the inspection itself.
export const TRIGGER_CONTEXT_BY_EVENT = {
  follow_up: "after report delivery.",
};

// Full sentence for manual/immediate triggers, which have no configurable
// offset. Keyed by trigger_type, then event_type. A missing entry falls back
// to the backend's generic trigger_display ("Manual", "Immediate"), so every
// supported event type should appear here.
export const TRIGGER_DESCRIPTION = {
  manual: {
    schedule_notification: "Send manually once a job is created.",
    report_delivery: "Send manually after the report is compiled.",
    payment_request: "Send manually to request payment from the client.",
  },
  immediate: {
    booking_confirmation:
      "Send immediately after a booking request is made via your link.",
    contract_sent: "Send immediately after the contract is sent.",
    contract_confirmation:
      "Send immediately after the client signs the contract.",
    payment_confirmation: "Send immediately after payment is received.",
    payment_refunded: "Send immediately after a refund is issued.",
  },
};
